import React, {ReactNode} from "react";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import AnnotationRectangle from "./AnnotationRectangle";
import {Annotation, Markup, MetadataRectangle} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import {PaperclipIcon} from "../../../../shared/annotation/icon/PaperclipIcon";
import {Icons} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources/operation/Icons";
import {PushPinIcon} from "../../../../shared/annotation/icon/PushPinIcon";
import {TagIcon} from "../../../../shared/annotation/icon/TagIcon";
import {GraphIcon} from "../../../../shared/annotation/icon/GraphIcon";

export class FileAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	private renderIcon(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");
		let opacity: number = FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100;
		let width: number = FunctionHelper.applyValue(rectBoundaries.width, 20);
		let height: number = FunctionHelper.applyValue(rectBoundaries.height, 20);
		let iconName = FunctionHelper.applyValue(annotation.iconName, "");

		switch (iconName.toLowerCase()) {
			case Icons.None.toLowerCase():
				return null;
			case Icons.Graph.toLowerCase():
				return <GraphIcon width={width} height={height} language={this.props.language} opacity={opacity}
								  color={color}/>;
			case Icons.PushPin.toLowerCase():
				return <PushPinIcon width={width} height={height} language={this.props.language} opacity={opacity}
									color={color}/>;
			case Icons.Tag.toLowerCase():
				return <TagIcon width={width} height={height} language={this.props.language} opacity={opacity}
								color={color}/>;
			default:
				return <PaperclipIcon width={width} height={height} language={this.props.language} opacity={opacity}
									  color={color}/>;
		}
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");

		return (
			<AnnotationRectangle {...this.props} {...rectBoundaries} popupContent={annotation.contents}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 popupCreator={annotation.markup?.creator} popupColor={color}
								 creationDate={annotation.markup?.creationDate}
								 style={{
									 zIndex: 0
								 }}>
				{this.renderIcon()}
			</AnnotationRectangle>
		);
	}
}